/* eslint-disable max-len */
import { OV_EMS_CDN } from '../../config/theme';
var alt = 'A graphic image of white polka dots on a black background.';
var disclaimerPreSubmit = 'By submitting your phone number, you agree to receive recurring automated marketing text messages. Consent is not a condition of purchase. Reply HELP for help and STOP to cancel. Message frequency varies by account. Message and data rates may apply. See <a href="/privacy-policy">Privacy Policy</a> and <a href="https://assets.conciergeteam.co/clients/outdoorvoices/sms_terms.html">SMS Terms</a>';
var disclaimerPostSubmit = 'Review <a href="/privacy-policy">Privacy Policy</a> and <a href="https://assets.conciergeteam.co/clients/outdoorvoices/sms_terms.html">SMS Terms</a>';
var imageRoot = "".concat(OV_EMS_CDN, "media/pages/");
var props = {
  blurb: 'Sign up for texts, be the first to know when Black Polka drops. Sounds like a pretty good trade if you ask us.',
  disclaimerPreSubmit: disclaimerPreSubmit,
  disclaimerPostSubmit: disclaimerPostSubmit,
  imageDesktop: {
    alt: alt,
    src: "".concat(imageRoot, "waitlist-polka-desktop.jpg")
  },
  imageTablet: {
    alt: alt,
    src: "".concat(imageRoot, "waitlist-polka-tablet.jpg")
  },
  imageMobile: {
    alt: alt,
    src: "".concat(imageRoot, "waitlist-polka-mobile.jpg")
  },
  isSMSForm: true,
  success: {
    message: 'Look out for a text message from us soon. Please reply JOIN to opt in.',
    title: 'Game On.'
  },
  title: 'Digits for Dots.',
  utmCampaign: 'polka_dot_launch'
};
export default props;